import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';

interface Props {
    title: string;
    text: string;
    cancelButtonText: string;
    confirmButtonText: string;
    open: boolean;
    handleClose: (confirm: boolean) => void;
}

const ConfirmDialog: React.FC<Props> = ({ title, text, open, cancelButtonText, confirmButtonText, handleClose }) => {
    return (
        <Dialog
            open={open}
            onClose={() => handleClose(false)}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
        >
            <DialogTitle id="alert-dialog-title">{title}</DialogTitle>
            <DialogContent>
            <DialogContentText id="alert-dialog-description">
                {text}
            </DialogContentText>
            </DialogContent>
            <DialogActions>
            <Button onClick={() => handleClose(false)} color="primary">
                {cancelButtonText}
            </Button>
            <Button onClick={() => handleClose(true)} color="primary" autoFocus>
                {confirmButtonText}
            </Button>
            </DialogActions>
        </Dialog>
    )
}

export default ConfirmDialog;